import { Helmet } from 'react-helmet-async'

import type { Typography as TTypography } from '@tribeplatform/design-system/types'
import { RadioGroup } from '@tribeplatform/react-ui-kit/RadioGroup'
import {
  legacyTypographyModules,
  resolveTypography,
  TTypographyModules,
  typographyModules,
} from '@tribeplatform/react-ui-kit/ThemeProvider'

import { useCustomizer, useCustomizerTheme } from '../hooks/index.js'
import { CustomizerActionType } from '../types.js'

export const AppearanceTypography = () => {
  const { dispatch } = useCustomizer()
  const { appearance } = useCustomizerTheme()

  const { typography } = appearance
  const { id: typographyTheme } = typography

  const setFontFamily = (typographyTheme: TTypographyModules) => {
    dispatch({
      type: CustomizerActionType.NEW_UPDATE,
      payload: {
        theme: {
          typography: {
            theme: typographyTheme,
          },
        },
      },
    })
  }

  return (
    <div className="space-y-5">
      <RadioGroup
        value={typographyTheme}
        onChange={setFontFamily}
        variant="cards"
      >
        <RadioGroup.Items>
          {typographyModules
            .filter(
              key => key === 'system' || !legacyTypographyModules.includes(key),
            )
            .map(key => {
              const typography = resolveTypography(key)
              return (
                <RadioGroup.Item key={key} value={key}>
                  <SingleTypographyView typography={typography} />
                </RadioGroup.Item>
              )
            })}
        </RadioGroup.Items>
      </RadioGroup>
    </div>
  )
}

const extractFontName = (fontFamily: string) => {
  return fontFamily?.split(',')[0].replace(/'/g, '')
}

const SingleTypographyView = ({ typography }: { typography: TTypography }) => {
  const { id, font, name } = typography
  const headingFontFamily = font['family-display']
  const bodyFontFamily = font['family-sans']

  const headingFontName = extractFontName(headingFontFamily)
  const bodyFontName = extractFontName(bodyFontFamily)

  const hasDifferentFontNames =
    !legacyTypographyModules.includes(id) && headingFontName !== bodyFontName

  return (
    <>
      {font.url && (
        <Helmet>
          <link id={id} href={font.url} rel="stylesheet" type="text/css" />
        </Helmet>
      )}
      <div className="w-full flex flex-col">
        {hasDifferentFontNames ? (
          <>
            <div
              className="font-medium text-lg"
              style={{
                fontFamily: headingFontFamily,
              }}
            >
              {headingFontName}
            </div>
            <div
              style={{
                fontFamily: bodyFontFamily,
              }}
            >
              {bodyFontName}
            </div>
          </>
        ) : (
          <div
            className="font-medium text-lg"
            style={{
              fontFamily: headingFontFamily,
            }}
          >
            {name}
          </div>
        )}
      </div>
    </>
  )
}
